// @flow

import * as React from 'react';

type Props = {
  children: any,
};

class RenderFirst extends React.Component<Props> {
  props: Props;
  render() {
    const { children } = this.props;
    const child = children.find(ch => !!ch);
    if (!child) return null;
    return child;
  }
}

export default RenderFirst;
